import FormatListBulletedRoundedIcon from '@material-ui/icons/FormatListBulletedRounded';
import { useSlate } from 'slate-react';
import {
  isBlockActive,
  toggleBlock,
} from '../../../../../RichTextEditorV2/utils/SlateUtilityFunctions';
import { RTE_TOOLBAR_BLOCKS } from '../../constants/RTEToolbar.blocks';
import { ToolbarButton } from '../ToolbarButton/ToolbarButton';
import { IToolbarButton } from '../ToolbarButton/ToolbarButton.interfaces';

export const UnorderedListTool = () => {
  const editor = useSlate();

  const handleToggleUnorderedList: IToolbarButton['onMouseDown'] = (e) => {
    e.preventDefault();
    toggleBlock(editor, RTE_TOOLBAR_BLOCKS.UNORDERED_LIST);
  };

  return (
    <ToolbarButton
      active={isBlockActive(editor, RTE_TOOLBAR_BLOCKS.UNORDERED_LIST)}
      onMouseDown={handleToggleUnorderedList}
    >
      <FormatListBulletedRoundedIcon />
    </ToolbarButton>
  );
};
